import { requestIdleCallback } from './RequestIdleCallback';
import { ABUtils } from './ABUtils';

let prefetched = false;

// The iframe has 2 goals: init OFJSESSIONID and prefetch frontend-html5 js at idle time (it doesn't execute any JS)
const appendIframe = () => {
    const iframe = document.createElement('iframe');
    iframe.src = document.location.origin + '/travel/prefetch.jsp';
    iframe.style.display = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    document.body.appendChild(iframe);
};

const prefetchFlightsAssets = () => {
    appendIframe();
};

export const prefetchAssets = () => {
    const { isStreamSearch } = ABUtils.getABs();
    if (isStreamSearch && !prefetched) {
        requestIdleCallback(prefetchFlightsAssets);
        prefetched = true;
    }
};
